import animateValue, { updateHeight } from "../utils/animateValue";

export const setContent_ = {
    methods: {
        setContentHeight(element, currentValue, progress) {
            this.contentHeight = currentValue;
            this.animationProgress = progress;
        },
    },
};

export const animateContent_ = {
    methods: {
        animateContentHeight(i) {
            animateValue(
                this.$refs.content,
                updateHeight,
                this.$refs.content.offsetHeight,
                !this.dropdowns[i].isOpen
                    ? 0
                    : this.$refs.content.scrollHeight > 300
                    ? 300
                    : this.$refs.content.scrollHeight,
                this.animationDuration
            );
        },
    },
};

export const closeDropDown_ = {
    methods: {
        closeDropdown(i) {
            this.dropdowns[i].isOpen = false;
        },
    },
};

export const toggleDropdown_ = {
    methods: {
        toggleDropDown(i) {
            this.dropdowns[i].isOpen = !this.dropdowns[i].isOpen;
            this.animateContentHeight(i);
        },
    },
};

export const clickOutSide_ = {
    directives: {
        "click-outside": {
            bind(el, binding, vnode) {
                el.clickOutsideEvent = function(event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        updateHeight(el.nextElementSibling, 0);
                        const passedValue = binding.value;
                        const componentInstance = vnode.context;
                        componentInstance.closeDropdown(passedValue);
                    }
                };
                document.body.addEventListener("click", el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener("click", el.clickOutsideEvent);
            },
        },
    },
};
